import {configureApiRequestErrorHelpers} from 'swayok-react-mdb-ui-kit/helpers/api/ApiRequestErrorHelpers'
import {appUrl} from './AppUrl'
import {trans} from './helpers'

// Настройка сервисов приложения после определения языка и региона.
export const configureAfterLocalizationLoaded = () => {
    // Настройка обработки ошибок от API.
    configureApiRequestErrorHelpers({
        logoutRoute: () => appUrl().logout,
        translator() {
            return trans().http_error
        },
    })
}
